module.exports = __webpack_public_path__ + "static/tanoto-mokup-aa4f3e801437a75700df54bf7ffc12a2.png";